import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "nav-tab-bar" }
const _hoisted_2 = { class: "nav-tab-inner" }
const _hoisted_3 = {
  class: "nav-tab-item-wrapper",
  ref: "innerEl"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "before", {}, undefined, true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true),
        _createElementVNode("div", {
          class: _normalizeClass(["active-underline", {'init': !_ctx.initialiseTabAsCurrent}]),
          ref: "underline",
          style: _normalizeStyle({left: _ctx.left, width: _ctx.width})
        }, null, 6)
      ], 512)
    ]),
    _renderSlot(_ctx.$slots, "after", {}, undefined, true)
  ]))
}